import React from "react";
import { Grid, Skeleton } from "@mui/material";

/**
 * Skeleton loader component for news cards
 */
const NewsSkeleton = ({ count = 3 }) => {
  return (
    <Grid item container lg={12} md={12} sm={12} xs={12} flexWrap={"wrap"} display={"flex"} justifyContent={"space-between"} className="mt-3">
      {Array.from({ length: count }).map((_, index) => (
        <Grid 
          key={index} 
          item 
          container 
          lg={3.8} 
          md={3.8} 
          sm={12} 
          xs={12} 
          backgroundColor={"#F2F2F2"} 
          borderRadius={"20px"} 
          className="mb-4"
        >
          {/* Image skeleton */}
          <Grid 
            item 
            container 
            lg={12} 
            md={12} 
            sm={12} 
            xs={12} 
            overflow={"hidden"} 
            justifyContent={"center"} 
            alignItems={"center"} 
            height={"30vh"}
          >
            <Skeleton 
              variant="rectangular" 
              width="100%" 
              height="100%" 
              animation="wave"
              sx={{ borderRadius: "20px 20px 0 0" }}
            />
          </Grid>
          
          {/* Content skeleton */}
          <Grid item container lg={12} md={12} sm={12} xs={12} flexDirection={"column"} padding={"4%"}>
            {/* Date skeleton */}
            <Skeleton 
              variant="text" 
              width="40%" 
              height={20} 
              animation="wave"
              sx={{ mb: 1 }}
            />
            
            {/* Title skeleton */}
            <Skeleton 
              variant="text" 
              width="100%" 
              height={24} 
              animation="wave"
              sx={{ mb: 1 }}
            />
            <Skeleton 
              variant="text" 
              width="90%" 
              height={24} 
              animation="wave"
              sx={{ mb: 1 }}
            />
            <Skeleton 
              variant="text" 
              width="70%" 
              height={24} 
              animation="wave"
              sx={{ mb: 2 }}
            />
            
            {/* Continue link skeleton */}
            <Skeleton 
              variant="text" 
              width="30%" 
              height={20} 
              animation="wave"
            />
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default NewsSkeleton;
